var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b-onboarding__right"},[_c('div',{staticClass:"b-onboarding__title"},[_vm._v("Thank you!")]),_c('div',{staticClass:"b-onboarding__subtitle"},[_vm._v("Your onboarding was successful. Let's get started.")]),_c('onboarding-back-and-forth',{attrs:{"get-started":true,"disabled":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }